
jQuery('a.h-close').click(()=>{
     jQuery('a.h-close').hide();
    jQuery('a.h-menu').show();
    jQuery('.header__inline-menu').toggle();
   
});
jQuery('a.h-menu').click(()=>{
     jQuery('a.h-close').show();
    jQuery('a.h-menu').hide();
    jQuery('.header__inline-menu').toggle();
   
});



jQuery("a#m-read").click(function(){
    let a = jQuery(this).text();
    if( a == "Read more" ){
        jQuery(this).text("Read less");
    }
    else{
        jQuery(this).text("Read more");
    }
    jQuery(this).closest("li.multicolumn-list__item.grid__item").toggleClass("h-shw");
    console.log("aadds");
});


jQuery("select.select__select.humayun").change(function(){
       var hprice = jQuery(this).children("option:selected").attr("data-price");  
    console.log(hprice); 
    jQuery("span.price-item").html(hprice);
  
    var hopt = jQuery(this).children("option:selected").val();  
    var hhval = jQuery(this).attr("data-hprod");  
    console.log(hopt);
     console.log(hhval);
    jQuery("#"+hhval).val(hopt);
  
});




 // function instantBuy(){
 //     var $ = jQuery;
 //     var formParams = $('form.cart').serialize();
 //     $.ajax({
 //      url: "/cart/add",
 //      type: "post",
 //      data: formParams,
 //      success: function(){
 //       window.location.href = "/checkout";
 //      },
 //      error: function(){
 //      }
 //     })
 //    }

 //    function addToCart(){
 //     $('form.cart').submit();
 //    }